import React, {
  Component,
} from 'react'
import styled from 'styled-components';
import GlobalStyle from 'stylecomponents/globalstyle';
import BannerItem from 'components/home/Banner/BannerItem';
import CupoyImage from 'components/commons/CupoyImage';
import PropTypes from 'prop-types';
import GLOBAL from 'nonnglobal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';

/**
 * Variables
 */
const BANNER_HEIGHT = 265;

/**
 * Styled
 */
const BannerContainer = GlobalStyle.BasicBlock.extend`
  background-color: #fff;
  height: ${BANNER_HEIGHT + 1}px;
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 1fr 274px;
  overflow: hidden;
  margin-bottom: ${GlobalStyle.ViewSpace}px;
`;
const SlideWrapper = styled.div`
  transform: ${props => `translateY(${props.translateValue}px)`};
  transition: transform ease-out 0.45s;
`;
const List = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const SlideImage = styled.div`
  height: ${BANNER_HEIGHT}px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: cover;
`;

/**
 * Components
 */
const Banner = props => {

  const {
    topAD,
    adClick,
  } = props;

  const {
    advid,
    clickurl,
    filepath,
    advname = '',
    createtime,
    updatetime,
  } = topAD;
  let ttime = createtime;
  if (updatetime > 0)  ttime = updatetime;
  const src = `${GLOBAL.imgSrcRootURL}/adimg/${advid}/${filepath}?t=${ttime}`;

  const handleClick = () => {
    adClick(advid);
  };

  return (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={clickurl}
      alt={advname}
    >
      <CupoyImage
        src={src}
        stylecomponent={SlideImage}
        isBackgroundImage
        onClick={handleClick}
      />
    </a>
  );
};

/**
 * Main Component
 */
class BannerView extends Component {

  static propTypes = {
    topADList: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0,
      translateValue: 0,
      slideHeight: 0,
    }

    this.timer = null;
  }

  componentDidMount() {
    this.timer = setInterval(this.autoNextSlide.bind(this), 5000);
    this.handleADImpress();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentIndex !== prevState.currentIndex) {
      this.handleADImpress();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  goToNextSlide = nextIndex => {
    this.setState({
      translateValue: -(nextIndex * BANNER_HEIGHT),
      currentIndex: nextIndex,
    });
  }

  autoNextSlide = () => {

    let { topADList = [] } = this.props;
    let { currentIndex } = this.state;
    
    if(currentIndex === (topADList.length - 1)) {
      this.goToNextSlide(0)
      return;
    };
    this.goToNextSlide(currentIndex + 1);
  }

  adClick = advid => {
    this.props.adActions.adClick(advid);
  };

  handleADImpress = () => {

    const {
      topADList,
    } = this.props;

    const {
      currentIndex,
    } = this.state;

    this.props.adActions.adImpress(topADList[currentIndex].advid);
  };

  render() {

    const {
      topADList,
    } = this.props;

    const {
      currentIndex,
    } = this.state;

    return (
      <BannerContainer>
        <SlideWrapper translateValue={this.state.translateValue} >
          {topADList.map(topAD => {
            return (
              <Banner
                key={topAD.advid}
                topAD={topAD}
                adClick={this.adClick}
              />
            );
          })}
        </SlideWrapper>
        <List>
          {topADList.map((topAD, index) => {

            // currentIndex小於6的話代表在第一頁，index大於5的就都不顯示( 不顯示第二頁 )，後台最多可以設定10筆
            if (currentIndex < 6 && index >= 6) {
              return null;
            }

            // currentIndex超過6的話代表翻到第二頁，index < 6的就都不顯示( 不顯示第一頁 )，後台最多可以設定10筆
            if (currentIndex >= 6 && index < 6) {
              return null;
            }

            const {
              advid,
              advname = '',
            } = topAD;

            return (
              <BannerItem
                key={advid}
                title={advname.trim()}
                currentIndex={currentIndex}
                index={index}
                goToNextSlide={this.goToNextSlide}
              />
            );
          })}
        </List>
      </BannerContainer>
    )
  }
}

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    adActions: bindActionCreators(actionCreators.adActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(null, mapActionToProps)(BannerView);